import React from 'react';
import PropTypes from 'prop-types';
import { Typography, SvgIcon } from '@mui/material';
import Modal from 'mui/components/elements/DS_Modal';

import { ReactComponent as EventBusyOutlinedIcon } from 'mui/assets/icons/event-busy.svg';

import { StyledModalContent } from './CancellationSuccessModalStyles';

function SuccessModal({ data, open, handleClose }) {
  return (
    <Modal open={open} handleClose={handleClose} aria-describedby="modal-description">
      <StyledModalContent>
        <SvgIcon component={EventBusyOutlinedIcon} inheritViewBox />
        <Typography id="modal-description" component="p" variant="DS_copyBigRegular">
          {data.successMessage}
        </Typography>
      </StyledModalContent>
    </Modal>
  );
}

SuccessModal.propTypes = {
  data: PropTypes.shape({
    successMessage: PropTypes.string.isRequired,
  }),
};

export default SuccessModal;
